import { render } from "./ChooseUs.vue?vue&type=template&id=4c12f00b"
import script from "./ChooseUs.vue?vue&type=script&lang=js"
export * from "./ChooseUs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__